export const availableLanguages = ["en", "fr"];
